import { Injectable, OnDestroy } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { MarkupService } from './markup-table/markup.service';
import { Markup } from './markup-table/model/markup.model';

@Injectable({
  providedIn: 'root'
})
export class SupportService implements OnDestroy {
  markups: Markup[] = [];

  private readonly moneyFormatter = new Intl.NumberFormat('ua-UA', {
    style: 'currency',
    currency: 'UAH'
  });

  newMarkupEvent: Subscription;

  deleteMarkupEvent: Subscription;

  constructor(private markupService: MarkupService) {
    this.newMarkupEvent = this.markupService.createEvent.subscribe(() => {
      this.loadMarkups();
    });
    this.deleteMarkupEvent = this.markupService.deleteEvent.subscribe(() => {
      this.loadMarkups();
    });
    this.loadMarkups();
  }

  ngOnInit(): void {
    this.loadMarkups();
  }

  async loadMarkups() {
    this.markups = await firstValueFrom(this.markupService.search());
  }

  ngOnDestroy() {
    this.newMarkupEvent.unsubscribe();
    this.deleteMarkupEvent.unsubscribe();
  }

  formatDate(date: Date) {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  formatMoney(number: number | undefined): string {
    return this.moneyFormatter.format(Number(number || 0));
  }

  getRetailPrice(price: any, coef = 1): number {
    price = Number(String(price).replace(/,/g, '.').replace(/\s/g, ''));

    const markup = this.markups
      .filter((row) => !row.folder && !(row.brands || []).length)
      .filter((row) => {
        const rangeEnd = row.rangeEnd === null || row.rangeEnd === undefined ? Infinity : row.rangeEnd;
        return price >= row.rangeStart && price <= rangeEnd;
      })
      .reduce<Markup | null>((selected, current) => {
        if (!selected) return current;
        if (selected.priority !== current.priority) {
          return selected.priority > current.priority ? selected : current;
        }
        return selected.id > current.id ? selected : current;
      }, null);

    const round = Number(markup?.round || 10);
    const safeRound = round > 0 ? round : 10;
    if (markup?.type === 'Фиксированная') {
      return Math.round(((price + Number(markup.markup || 0)) * coef) / safeRound) * safeRound;
    }

    const percent = markup?.markup || 30;
    const result = Math.round((price * (percent / 100 + 1) * coef) / safeRound) * safeRound;
    return result;
  }
}
